export default __webpack_public_path__ + "static/media/client3.8e11b410.webp";